module.exports = __webpack_public_path__ + "img/map2_pl.d9767f92.svg";